// import * as types from '../mutation-types'
// import prService from '../api/services/pr'

// import prService from "../api/services/prService"
import Driver from 'driver.js' // import driver.js
// import 'driver.js/dist/driver.min.css' // import driver.js css

const state = { // คล้าย data
  driver:null
}
// call state
// this.#store.state.[filename].name
// this.#store.state.prDoc.name

const mutations = { // คล้าย property
  showGuide (state, payload) {
    if (!state.driver) {
      console.log(state.driver)
      state.driver = new Driver({
        className: 'scoped-class',        // className to wrap driver.js popover
        animate: false,                    // Whether to animate or not
        opacity: 0.75,                    // Background opacity (0 means only popovers and without overlay)
        padding: 10,                      // Distance of element from around the edges
        allowClose: true,                 // Whether the click on overlay should close or not
        overlayClickNext: true,          // Whether the click on overlay should move next
        doneBtnText: 'จบ',              // Text on the final button
        closeBtnText: 'ปิด',            // Text on the close button for this step
        stageBackground: '#ffff00',       // Background color for the staged behind highlighted element
        nextBtnText: 'ต่อไป',              // Next button text for this step
        prevBtnText: 'ก่อนห้า',          // Previous button text for this step
        showButtons: false,               // Do not show control buttons in footer
        keyboardControl: true,            // Allow controlling through keyboard (escape to close, arrow keys to move)
        scrollIntoViewOptions: {},        // We use `scrollIntoView()` when possible, pass here the options for it if you want any
        onHighlightStarted: (Element) => {console.log('driver.js onHighlightStarted',Element)}, // Called when element is about to be highlighted
        onHighlighted: (Element) => {console.log('driver.js onHighlighted',Element)},      // Called when element is fully highlighted
        onDeselected: (Element) => {console.log('driver.js onDeselected',Element)},       // Called when element has been deselected
        onReset: (Element) => {console.log('driver.js onReset',Element)},            // Called when overlay is about to be cleared
        onNext: (Element) => {console.log('driver.js onNext',Element)},                    // Called when moving to next step on any step
        onPrevious: (Element) => {console.log('driver.js onPrevious',Element)},                // Called when moving to previous step on any step
      })
    }
    state.driver.defineSteps(payload)
    state.driver.start()
  },
  showGuideEvent (state, payload) {
    state.driver = new Driver({
      className: 'scoped-class',        // className to wrap driver.js popover
      animate: false,                    // Whether to animate or not
      opacity: 0.75,                    // Background opacity (0 means only popovers and without overlay)
      padding: 10,                      // Distance of element from around the edges
      allowClose: true,                 // Whether the click on overlay should close or not
      overlayClickNext: true,          // Whether the click on overlay should move next
      doneBtnText: 'จบ',              // Text on the final button
      closeBtnText: 'ปิด',            // Text on the close button for this step
      stageBackground: '#ffff00',       // Background color for the staged behind highlighted element
      nextBtnText: 'ต่อไป',              // Next button text for this step
      prevBtnText: 'ก่อนห้า',          // Previous button text for this step
      showButtons: false,               // Do not show control buttons in footer
      keyboardControl: true,            // Allow controlling through keyboard (escape to close, arrow keys to move)
      scrollIntoViewOptions: {},        // We use `scrollIntoView()` when possible, pass here the options for it if you want any
      onHighlighted: payload.onHighlighted,
      onDeselected: payload.onDeselected,
      onReset: payload.onReset,
      onNext: payload.onNext,
      onPrevious: payload.onPrevious,
      onHighlightStarted: payload.onHighlightStarted
    })
    state.driver.defineSteps(payload.step)
    state.driver.start()
  },
}
// call mutations
// this.$store.commit('[mutationName]',{name:'pom'})
// this.$store.commit('showGuide',{name:'pom'})

const actions = {  // ก็เหมือน Methods แต่จะต่างตรงที่ จะเรียก mutations แบบ async
  showGuide ({commit}, playload) {
    commit('showGuide', playload)
  },
  showGuideEvent ({commit}, playload) {
    commit('showGuideEvent', playload)
  },  
}
// call actions
// this.$store.dispatch('[actionName]')
// this.$store.dispatch('showGuide')


const getters = { // คล้าย Compute
  driver (state) {
    return state.driver
  },
}
//call getters  this.$store.getters.[getterName]
// this.$store.getters.nameLen


export default {
  state,
  mutations,
  getters,
  actions
}
